import { Link } from "react-router-dom";
import { LegalShell, Section, UPDATED } from "@/pages/Legal";

const Mail = () => <a href="mailto:shaurya@sanghviinfo.com" className="text-[#B8A4FF] hover:underline">shaurya@sanghviinfo.com</a>;

export default function RefundPolicy() {
  return (
    <LegalShell eyebrow="LEGAL" title="Refund & cancellation policy" updated={UPDATED} testid="refund-page"
      seo={{ title: "Refund Policy", description: "Studivault refund and cancellation policy for one-time 30-day Plus and Pro passes, in line with the Consumer Protection (E-Commerce) Rules, 2020.", path: "/refund-policy" }}>
      <p>
        This policy applies to purchases on Studivault (studivault.com), operated by <strong>Bloc Metric</strong>,
        India, and is published under the Consumer Protection (E-Commerce) Rules, 2020.
      </p>

      <Section n={1} title="What you buy">
        Plus and Pro are <strong>one-time purchases of a 30-day pass</strong> that unlock premium features
        immediately after successful payment. Passes do not auto-renew and there is no recurring charge, so no
        cancellation is needed to stop future billing. Total price, including applicable taxes, is shown before
        you pay.
      </Section>

      <Section n={2} title="Cancellation">
        As passes are digital services activated instantly, a purchase cannot be cancelled once the pass is
        activated, except as stated below. If payment fails or the pass is not activated, no charge is retained.
      </Section>

      <Section n={3} title="When you are eligible for a refund">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>You were charged more than once for the same purchase (duplicate charge).</li>
          <li>You were charged but your plan was not activated and we could not fix it within 48 hours.</li>
          <li>A major premium feature was unavailable for a substantial part of your pass due to a fault on our side.</li>
          <li>You request a refund within <strong>7 days</strong> of purchase and have made minimal use of premium features (for example, fewer than 3 premium generations).</li>
        </ul>
        <p>Refunds are not provided for change of mind after substantial use, for unused remaining days, for accounts terminated for breach of the <Link to="/terms" className="text-[#B8A4FF] hover:underline">Terms</Link>, or for gems, XP or other virtual rewards, which have no cash value.</p>
      </Section>

      <Section n={4} title="How to request">
        Email <Mail /> from your account email with your order or payment ID, date and reason. We will
        acknowledge within 48 hours and decide within 7 working days.
      </Section>

      <Section n={5} title="Processing">
        Approved refunds are issued to the original payment method through Razorpay within 5–7 working days
        of approval. Your bank or card issuer may take additional time to credit the amount. Your premium
        access may be withdrawn once a refund is processed.
      </Section>

      <Section n={6} title="Complaints">
        If you are unhappy with a decision, contact our <Link to="/grievance" className="text-[#B8A4FF] hover:underline">Grievance Officer</Link>.
        This does not affect your statutory rights under the Consumer Protection Act, 2019.
      </Section>
    </LegalShell>
  );
}
